import { Capacitor } from '@capacitor/core';
import { FirebaseApp, initializeApp } from 'firebase/app';

import { FIREBASE_API } from 'src/config-global';

// ----------------------------------------------------------------------

// Cached Firebase app instance
let cachedFirebaseApp: FirebaseApp | null = null;

/**
 * Get Firebase app instance for web SDK features (Firestore, RemoteConfig, Auth, etc.)
 *
 * On web platforms: Uses the default Firebase app (no name)
 * On native platforms: Uses a named app 'web-services' for web SDK features
 *
 * IMPORTANT: This function should be used for ALL Firebase web SDK operations
 * (Auth, Firestore, RemoteConfig, Storage, etc.) to ensure consistent auth state.
 */
export function getFirebaseWebApp(): FirebaseApp {
  if (cachedFirebaseApp) {
    return cachedFirebaseApp;
  }

  if (Capacitor.isNativePlatform()) {
    // On native platforms, create a named app for web SDK services
    // This is separate from the native Firebase SDK (initialized by google-services.json)
    // Auth state must be synced manually via signInWithCustomToken
    console.log('[Firebase] Creating web-services app for native platform');
    cachedFirebaseApp = initializeApp(FIREBASE_API, 'web-services');
  } else {
    // On web, use the default app (no name) for session persistence compatibility
    console.log('[Firebase] Creating default app for web platform');
    cachedFirebaseApp = initializeApp(FIREBASE_API);
  }

  return cachedFirebaseApp;
}

// Legacy export for backward compatibility (not used anymore)
// All code should use getFirebaseWebApp() instead
export const firebaseAppOnlyForWeb: FirebaseApp | null = null;
